import { render } from "./BetLimitSettings.vue?vue&type=template&id=e10b50e6&scoped=true"
import script from "./BetLimitSettings.vue?vue&type=script&lang=js"
export * from "./BetLimitSettings.vue?vue&type=script&lang=js"

import "./BetLimitSettings.vue?vue&type=style&index=0&id=e10b50e6&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e10b50e6"]])

export default __exports__